import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <div className="copyright">
                <p>Copyright © Md.Yeasin Arafat founder of <strong><span className='text-logo'>Code</span>-Bx</strong>.com</p>
            </div>
        </div>
    );
};

export default Footer;